/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Sidebar } from "@nordcloud/gnui";
import { SelectCustomerForm } from "./SelectCustomerForm";
import { useCustomerSelectorForm } from "./useCustomerSelectorForm";
import type { Customer } from "./useFetchCustomers";

type Props = {
  isOpen: boolean;
  customers: Customer[];
  onSubmit: (id: string, name: string, orgName: string) => void;
  onClose: () => void;
};

export function SelectCustomerSidebar({
  isOpen,
  customers,
  onSubmit,
  onClose,
}: Props) {
  const { onCustomerSelected, onSearchChange, resetSearch, filteredCustomers } =
    useCustomerSelectorForm({
      customers,
      onSubmit,
    });

  const handleSidebarClose = () => {
    resetSearch();
    onClose();
  };

  const handleCustomerSelected = (
    id: string,
    name: string,
    orgName: string
  ) => {
    resetSearch();
    onCustomerSelected(id, name, orgName);
  };

  return (
    <Sidebar isOpen={isOpen} title="Switch Tenant" onClick={handleSidebarClose}>
      <SelectCustomerForm
        customers={filteredCustomers}
        onCustomerSelected={handleCustomerSelected}
        onSearchChange={onSearchChange}
      />
    </Sidebar>
  );
}
